import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import '../css/Footer.css'
// import src from './assets/footer.png'
// import link from './assets/linkedin.png'
// import email from './assets/email.png'
import { NavLink, Link } from "react-router-dom";


const Footer = () => {


    return (
        <div  >
        <footer className="container" >
            <h2>AL-Makkah Fence House</h2>
            <p ><span style={{fontWeight:'bolder'}}>Address : </span>25 no Road Shahdra, Lahore, Punjab, Paksitan</p>
            <p ><span style={{fontWeight:'bolder'}}>Email : </span>Almakkahjalihouse@gmail.com</p>
            <p ><span style={{fontWeight:'bolder'}}>Contact 1 : </span> 03048444795</p>
            <p ><span style={{fontWeight:'bolder'}}>Contact 2 : </span> 03246001912</p>
            <p ><span style={{fontWeight:'bolder'}}>Contact 3 : </span>  03417522886</p>
        </footer>
        <div className="cop" >©2021 by Al-Makkah Iron Developers.</div>
        </div>
    )

}
export default Footer;